import React from 'react';
import NewAlarmIndicatorPage from './NewAlarmIndicatorPage';
import { connect } from 'react-redux';
import { configureActions } from '../../../../../actions/configure.action';
import Backend from '../../../../Layouts/Backend';
import Loading from '../../../../Helpers/Loading';
import helper from '../../../../../utils/helper';

class NewAlarmIndicator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alarmIndicators: [],
      remoteDevices: [],
      loading: false,
      errors: '',
      isSubmitting: false,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.configure.alarmIndicators !== prevState.alarmIndicators) {
      state.alarmIndicators = nextProps.configure.alarmIndicators;
    }
    if (nextProps.configure.remoteDevices !== prevState.remoteDevices) {
      state.remoteDevices = nextProps.configure.remoteDevices;
    }
    state.errors = helper.centralizeError([nextProps.configure.errors]);
    if (nextProps.configure.isSubmitting !== prevState.isSubmitting) {
      state.isSubmitting = nextProps.configure.isSubmitting;
    }
    if (nextProps.configure.loading !== prevState.loading) {
      state.loading = nextProps.configure.loading;
    }
    return Object.keys(state).length ? state : null;
  }

  async componentDidMount() {
    const { deptId } = this.props.match.params;
    await this.props.getAIsByDept(deptId);
    await this.props.getRDsByDept(deptId);
  }

  onCreateAlarmIndicator = (params) => {
    const departmentId = this.props.match.params.deptId;
    this.props
      .createAlarmIndicator({ ...params, departmentId })
      .then(() => this.props.history.goBack())
      .catch((err) => console.log(err));
  };
  render() {
    //prettier-ignore
    const { loading } = this.state;
    if (loading) {
      <Backend>
        <Loading />
      </Backend>;
    }
    return (
      <NewAlarmIndicatorPage
        {...this.state}
        onCreateAlarmIndicator={this.onCreateAlarmIndicator}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    configure: state.configure,
  };
}
export default connect(mapStateToProps, configureActions)(NewAlarmIndicator);
